import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'
import { formatDateTimesInText } from '../../utils/dateUtils'

export function useDeleteBlock() {
  const { t, i18n } = useTranslation(['blocks', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { deleter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const deleteBlock = async (courtId: number, blockId: number) => {
    setLoading(true)

    try {
      const data = await deleter(
        `${CONFIG.BOUNCE_API}/api/v1/courts/${courtId}/blocks/${blockId}`
      )

      setSuccess(t('blocks:blocks.successfully-deleted'))
      setError(null)

      return data
    } catch (caughtError) {
      console.log(caughtError)

      const message =
        caughtError instanceof ApiError
          ? formatDateTimesInText(
              getErrorMessage(caughtError.data),
              i18n.language
            )
          : t('exceptions:unknown')

      setError(message)
      throw new Error(message)
    } finally {
      setLoading(false)
    }
  }

  return {
    deleteBlock,
    loading,
    error,
    success,
    resetState,
  }
}
